//Money formatter for totals returned from AJAX calls
Number.prototype.formatMoney = function(c, d, t){
    var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

// Search Reveal Function
function searchReveal() {
  var headerSearchWrapper = document.getElementById('header-search-desktop');
  if(!headerSearchWrapper){ return; }

  var searchForms = headerSearchWrapper.getElementsByClassName('search-form');

  // Add listeners to all search forms
  for (var i = 0; i < searchForms.length; ++i) {

    // searchForms[i].style.width = searchForms[i].offsetWidth + 'px';
    // searchForms[i].style.height = searchForms[i].offsetHeight + 'px';
    var submitButton = searchForms[i].getElementsByClassName('search-form__submit')[0];

    searchForms[i].addEventListener('mouseover', function() {
    // submitButton.addEventListener('mouseover', function() {
      var searchInput = this.getElementsByClassName('search-form__input')[0];
      // var searchInput = this.parentNode.getElementsByClassName('search-form__input')[0];
      this.classList.add('form-open');
      // this.parentNode.classList.add('form-open');
      searchInput.classList.add('search-form__input--active');
      setTimeout(function() {
        searchInput.nextElementSibling.classList.add('search-icon--open');
      }, 500);
    });

    searchForms[i].addEventListener('mouseout', function() {
      var searchInput = this.getElementsByClassName('search-form__input')[0];
      this.classList.remove('form-open');
      searchInput.classList.remove('search-form__input--active');
      setTimeout(function() {
        searchInput.nextElementSibling.classList.remove('search-icon--open');
      }, 500);
    });

  }
} // End Search Reveal Function

// TODO: Replace with classListContains
function hasClass(element, className) {
  return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

//product detail scripts
//
//Cart scripts
//select variant for shopify add to add to cart
function selectVariant(el,type,pos){
  const position = pos;
  //Selecting if it's a button
  if(type == "dropdown"){
    const selected = el.options[el.selectedIndex].value;
    const options = document.getElementById('variantIdSelector').getElementsByTagName('option');
    for(let i = 0; i < options.length; i++){
      if(options[i].innerHTML == selected){
        options[i].selected = true;
      }
    }
    translateSelections(pos, selected);
  } else if (type == 'sizeButton'){
    //selecting if it's a button
    const buttons = document.getElementById('sizeButton').getElementsByClassName('buttonSelector--' + pos);
    const newValue = el.getAttribute('data-value');
    for(let i = 0; i < buttons.length; i++){
      buttons[i].setAttribute('data-selected','false')
      buttons[i].children[0].classList.remove('buttonSelected');
    }
    el.setAttribute('data-selected','true')
    el.children[0].classList.add('buttonSelected');
    translateSelections(pos, newValue);

  }
}
//Translate selected formats to the Shopify default functionality selection
function translateSelections(position, newValue){
  const pos = position - 1;
  const newVal = newValue;
  const selectorBlock = document.getElementById('variantIdSelector');
  //get the current selection and swap it out with the element that has changed
  let current = selectorBlock.options[selectorBlock.selectedIndex].innerHTML.split(' / ');
  current[pos] = newVal;
  var newString = current.join(' / ');
  //Find the option in the native shopify selection code and select that element
  const shopifyOptions = selectorBlock.getElementsByTagName('option');
  for(let i = 0; i < shopifyOptions.length; i++){
    if(shopifyOptions[i].innerHTML == newString){
      shopifyOptions[i].selected = true;
    }
  }
}

//Determine variable top of the product detail block for desktop and make it sticky on scroll.
function stickyBlock(id,parent){
  //determine initial height
  const block = document.getElementById(id);
  const par = document.getElementById(parent);
  //determine initial footer height for an endpoint and header height to set top margin at that endpoint
  const foot = document.getElementById('pageFooter').clientHeight;
  const head = document.getElementById('header').clientHeight;
  const overall = document.body.clientHeight - block.clientHeight - foot;
  //grab the initial clientWidth to preserve it when item has position fixed.
  const width = block.clientWidth + "px";
  const offset = block.offsetTop;
  const bottomBorder = foot - 55;
  const height = block.clientHeight + 30 + "px";
  // console.log(overall);

  let docHeight = (document.height !== undefined) ? document.height : document.body.offsetHeight;
  //determine scroll location and make or remove the fixedBlock sticky class from the container.
  document.addEventListener('scroll', function(){
    // console.log('scroll');
    let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if(scrollTop > offset - 35){
      block.classList.add('fixedBlock');
      // block.classList.remove('absBlock');
      // block.style.bottom = "-" + bottomBorder + "px";
      block.style.width = width;
      // block.style.height = height;
      if(par !== null){
        par.style.position = "static";
      }
    } else if(scrollTop < offset + 35){
      block.classList.remove('fixedBlock');
      block.style.width = width;
      if(par !== null){
        par.style.position = "static";
      }
    }
    // if (scrollTop > overall){
    //   block.classList.add('absBlock');
    //   block.style.bottom = "-" + bottomBorder + "px";
    //   block.style.width = width;
    //   block.style.height = "auto";
    //   // if(par !== null){
    //   //   par.style.position = "relative";
    //   // }
    // }
  });
}

var getFocusableElements = function(element) {
  var focusableElements = document.getElementById(element).querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');
  return focusableElements;
}

function swatchReveal(el, productId){
  //collection-products__product__options__color
  var parent = document.getElementById('color-options__' + productId);
  var colors = [];

  if(parent) {
    colors = parent.getElementsByClassName('color-option__label');
  } else {
    colors = document.getElementsByClassName('color-option__label');
  }

  var expander = el;
  var i;

  for(i = 0; i < colors.length; i++) {
    swatchExpand(colors);
  }
  el.style.display = "none";
}

function swatchExpand(colorWrappers) {
  // console.log(colorWrappers);
  var i;
  for(i = 0; i < colorWrappers.length; i++) {
    colorWrappers[i].classList.remove('hidden');
  }
}
